import {notiConstants} from '../_constants';

export const notiActions = {
    updateNoti,
};

function updateNoti(noti){
    return {type :notiConstants.NOTI_SUCCESS,noti};
}


// WEBPACK FOOTER //
// ./src/_actions/notification.actions.js